<template>

    <div class="section" :class="classes">
        <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="col" :class="col">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>

</template>

<style lang="scss">

    .section {

        border-top: 1px solid $color-rule;
        padding: 80px 0;
        position: relative;
        text-align: center;

        &.bg-dark {
            border: none;
            h3, h4, h5, p {
                color: #fff;
            }
        }

        h3 {
            @include font-semibold(24px);
            color: $color-text;
            margin: 0 0 20px 0;
            line-height: 1.4em;
            padding: 0;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 20px;
                text-align: center;
            }
        }

        h4 {
            @include font-semibold(20px);
            color: $color-text;
            margin: 0 0 20px 0;
            line-height: 1.4em;
            padding: 0;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 20px;
                text-align: center;
            }
        }

        h5 {
            @include font-semibold(13px);
            color: $color-primary;
            letter-spacing: 1px;
            margin: 0 0 10px 0;
            text-transform: uppercase;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 13px;
                text-align: center;
            }
        }

        p {
            @include font-medium(16px);
            color: $color-text;
            line-height: 1.8em;
            margin: 0 0 20px 0;
            padding: 0;
            &.small {
                font-size: 14px;
                line-height: 1.6em;
            }
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 14px;
                text-align: center;
            }
        }

    }

</style>

<script>

export default {

    props: {
        col: {
            type: String,
            default: 'col-12',
        },
        bg: {
            type: String,
            default: 'white',
        },
    },

    computed: {

        classes() {
            return {
                'bg-dark': this.bg === 'dark',
                'bg-grad': this.bg === 'grad',
                'bg-light': this.bg === 'light',
                'bg-white': this.bg === 'white',
                'bg-none': this.bg === 'none',
            }
        },

    },
}

</script>